import { useGenericDrillDown } from './useGenericDrillDown';

interface PeriodoParams {
  periodo?: string; // ex: "04/2025" ou "2025-04"
  sped_fiscal_id?: string | number;
}

export const useIcmsDebitosDrillDown = (establishmentId?: number | string | null) => {
  return useGenericDrillDown({
    endpoint: 'sped-fiscal/icms-debitos-periodo-drill-down',
    buildUrl: (baseUrl: string, params: PeriodoParams) => {
        const searchParams = new URLSearchParams();

        if (params.sped_fiscal_id) {
          searchParams.append('sped_fiscal_id', String(params.sped_fiscal_id));
        }

        if (!params.sped_fiscal_id && params.periodo) {
          searchParams.append('periodo', params.periodo);
        }

        if (establishmentId) {
          searchParams.append('establishment_id', String(establishmentId));
        }

        const query = searchParams.toString();
        const separator = query ? `?${query}` : '';
        return `${baseUrl}sped-fiscal/icms-debitos-periodo-drill-down${separator}`;
    },
    includeAuth: true,
    dataTransformer: (raw: any) => raw // sem transformação por enquanto
  });
}; 